<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>문제해결</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>{{ category }}</p>
                <!-- <ChevronRight :size="24"></ChevronRight> -->
                <!-- <p>{{ product_models[selectedProduct] }}</p> -->
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">솔루션 작성</p>

            <div style="width: 100%; height: 2px; background: black"></div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 20px"
        >
            <p style="font-size: 28px; font-weight: bold">제품 분류</p>
            <div
                class="product-list"
                style="display: flex; align-content: center"
            >
                <button
                    v-for="(category, index) in categoryList"
                    :key="category"
                    @click="clickCategory(index)"
                    :class="{ selected: index == selectedCategory }"
                    style="
                        border: 1px solid black;
                        border-radius: 20px;
                        padding: 8px 12px;
                        background: white;
                    "
                >
                    <p style="font-size: 16px">
                        {{ category }}
                    </p>
                </button>
            </div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 20px"
        >
            <p style="font-size: 28px; font-weight: bold">시리즈 분류</p>
            <div
                class="product-list"
                style="display: flex; align-content: center"
            >
                <button
                    v-for="(model, index) in subCategoryList"
                    :key="index"
                    @click="addModel(model)"
                    style="
                        border: 1px solid black;
                        border-radius: 20px;
                        padding: 8px 12px;
                        background: white;
                    "
                >
                    <p style="font-size: 16px">
                        {{ model.sub_category }}
                    </p>
                </button>
            </div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 20px"
        >
            <p style="font-size: 28px; font-weight: bold">선택된 제품</p>
            <div
                class="product-list"
                style="
                    display: flex;
                    align-content: center;
                    background: white;
                    border: 0px;
                "
            >
                <button
                    v-for="(model, index) in selectedModels"
                    :key="index"
                    style="
                        border: 1px solid black;
                        border-radius: 20px;
                        padding: 8px 12px;
                        background: white;
                    "
                >
                    <div class="row">
                        <p style="font-size: 16px">
                            {{ model.sub_category }}
                        </p>

                        <Close :size="20" @click="removeModel(model)"></Close>
                    </div>
                </button>
            </div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 40px 0px"
        >
            <p style="font-size: 28px; font-weight: bold">제목</p>
            <input
                type="text"
                v-model="title"
                style="
                    width: 80%;
                    height: 56px;
                    border: 1px solid #a2a2a2;
                    padding: 12px;
                "
            />
        </div>

        <div class="screen-width" style="height: auto; margin-bottom: 100px">
            <QuillEditor
                id="editor"
                v-model:content="content"
                contentType="html"
                theme="snow"
                :modules="modules"
                toolbar="full"
                @textChange="onEditorChange"
            />
        </div>
        <div class="row align-space-between screen-width">
            <p style="font-size: 28px; font-weight: bold">
                많이하는질문 키워드
            </p>
            <div
                class="product-list"
                style="display: flex; align-content: center"
            >
                <div v-for="category in selectedCategories" :key="category">
                    <p> {{categoryList[category]}}</p>
                    <div class="row" style="gap:16px; flex-wrap:wrap">
                    <button
                        v-for="(keyword, index) in keywordMap[
                            categoryList[category]
                        ]"
                        :key="index"
                        @click="clickKeyword(category, index)"
                        style="
                            border: 1px solid black;
                            border-radius: 20px;
                            padding: 8px 12px;
                            background: white;
                        "
                        :class="{ selected: Array.isArray(selectedKeyword[category]) && selectedKeyword[category].indexOf(keyword) !== -1 }"
                    >
                        <p style="font-size: 16px">
                            {{ keyword }}
                        </p>
                    </button>
                    </div>
                </div>
            </div>
        </div>
        <button
            style="
                width: 320px;
                height: 50px;
                background: #27afe2;
                border-radius: 20px;
                color: white;
                font-size: 32px;
                font-weight: bold;
                margin: 40px;
            "
            @click="submitSolution"
        >
            등록
        </button>
    </v-container>
</template>

<script>
import { ref, onMounted, computed, onUpdated } from "vue";
import { useStore } from "vuex";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
// import BlotFormatter from "quill-blot-formatter";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import Close from "vue-material-design-icons/Close.vue";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";

export default {
    name: "problem-layout",
    props: ["id"],
    components: {
        QuillEditor,
        ImageUploader,
        HomeOutline,
        Close,
    },
    setup() {
        const store = useStore();
        const images = ref([])

        const categoryList = [
            "GPS플로터",
            "레이더",
            "무선/통신장비",
            "항해 안전장비",
            "항해 조타장비",
            "해상용 안테나/헤딩센서",
            "선박용 인산철배터리",
            "선박용 전기관련 제품",
            "부품 및 액세서리",
        ];

        const keywordMap = {
            GPS플로터: [
                "전원",
                "재부팅",
                "사용중멈춤",
                "지도","해도",
                "네트워트","연동",
                "수심","수온",
                "포인트원",
                "헤딩선","코스선",
                "액정","화면","밝기",
                "목적지","항적",
                "중지됨",
                "초기화",
                "기타",
            ],
            레이더: [
                "전원",
                "레이더신호없음",
                "물표",
                "네트워트","연동",
                "무선국허가",
                "기타",
            ],
            "무선/통신장비": [
                "전원",
                "GPS연동",
                "송신","수신",
                "EPIRB자동발사",
                "EPIRB배터리교체",
                "EPIRB수압이탈기 교체",
                "코딩",
                "무선국허가",
                "AIS",
                "기타",
            ],
            "항해 안전장비": ["공급전압", "배율", "리모컨", "기타"],
            "항해 조타장비": ["선외기", "설치", "기타"],
            "해상용 안테나/헤딩센서": ["설치", "GPS안테나 연동", "기타"],
            "선박용 인산철배터리": [
                "배터리 용량",
                "셀등급",
                "크기","무게",
                "기타",
            ],
            "선박용 전기관련 제품": [],
            "부품 및 액세서리": [
                "송수파기 설치",
                "NMEA2000 전원",
                "송수파기 잡음",
                "따개비방지장비",
                "기타",
            ],
        };

        const subCategoryList = computed(() => {
            return store.getters.getSubCategoryList;
        });

        const modules = [
            {
                name: "imageUploader",
                module: ImageUploader,
                options: {
                    upload: (file) => {
                        return new Promise((resolve, reject) => {
                            store
                                .dispatch("uploadImage", file)
                                .then((res) => {
                                    images.value.push(res.data.filename);
                                    resolve(res.data.url);
                                })
                                .catch((err) => {
                                    reject("Upload failed");
                                    console.error("Error:", err);
                                });
                        });
                    },
                },
            },
        ];

        const onEditorChange = () => {
            // content.value = html;
        };

        const selectedCategory = ref(0);
        const selectedCategories = ref([])
        const selectedModels = ref([]);
        const selectedKeyword = ref({});
        const title = ref("");
        const content = ref("");

        const clickCategory = async (index) => {
            selectedCategory.value = index;
            await store.dispatch("getSubCategorySolutionList", selectedCategory.value);
        };

        const clickKeyword = (category, index) => {
            const keyword = 
                keywordMap[categoryList[category]][index];

            // if (
            //     selectedKeyword.value[category] ==
            //     keywordMap[categoryList[category]][index]
            // ) {
            //     selectedKeyword.value[category] = null;
            // } else {
            //     selectedKeyword.value[category] =
            //         keywordMap[categoryList[category]][index];
            // }
                // ✅ selectedKeyword.value[category]가 배열인지 확인 후, 없으면 초기화
            if (!Array.isArray(selectedKeyword.value[category])) {
                selectedKeyword.value[category] = [];
            }

            const selectedIndex = selectedKeyword.value[category].indexOf(keyword);

            if (selectedIndex !== -1) {
                // ✅ 이미 선택된 경우 -> 제거
                selectedKeyword.value[category].splice(selectedIndex, 1);
            } else {
                // ✅ 선택되지 않은 경우 -> 추가
                selectedKeyword.value[category].push(keyword);
            }
        };

        // const clickSubCategory = async (index) => {
        //     selectedSubCategory.value = index;
        //     await store.dispatch(
        //         "getCategoryProductList",
        //         subCategoryList.value[selectedSubCategory.value].id
        //     );
        // };

        const addModel = (model) => {
            // 제품분류 추가
            const isExistCategory = selectedCategories.value.some(
                (item) => item === model.main_category
            );

            if (!isExistCategory) {
                selectedCategories.value.push(model.main_category);
            }

            // 시리즈 추가
            const isExist = selectedModels.value.some(
                (item) => item.id === model.id
            );


            // 이미 존재하지 않는 경우에만 추가
            if (!isExist) {
                selectedModels.value.push(model);
            }
        };

        const removeModel = (model) => {
            selectedModels.value = selectedModels.value.filter(
                (item) => item.id !== model.id
            );

             // ✅ selectedModels에 남아 있는 모델들의 category 목록 가져오기
            const remainingCategories = new Set(
                selectedModels.value.map((item) => item.main_category)
            );

            // ✅ selectedCategories에서 남아 있는 모델들이 포함하지 않은 category 삭제
            selectedCategories.value = selectedCategories.value.filter(
                (category) => remainingCategories.has(category)
            );

        };

        const submitSolution = async () => {
            content.value = content.value.replaceAll(
                '<iframe class="ql-video"',
                '<iframe class="ql-video" style="width:960px; height:600px"'
            );

            content.value = content.value.replaceAll(
                'kumhomarinesvc.com/api/public/temp/',
                'kumhomarinesvc.com/api/public/img/'
            )

            const categoryIds = selectedModels.value.map(
                (category) => category.id
            );

            images.value = images.value.filter((image) => {
                return content.value.includes(image);
            });

            const solution = {
                title: title.value,
                detail: content.value,
                categoryIds: categoryIds,
                keyword: selectedKeyword.value,
                images: images.value,
            };

            await store
                .dispatch("addSolution", solution)
                .then(() => {
                    alert("Solution 등록 되었습니다");
                })
                .catch((error) => {
                    alert(error);
                });
        };

        onUpdated(() => {});

        onMounted(async () => {
            await store.dispatch("getSubCategorySolutionList", selectedCategory.value);
        });

        return {
            categoryList,
            content,
            onEditorChange,
            modules,
            title,
            selectedModels,
            addModel,
            removeModel,
            submitSolution,
            selectedCategory,
            subCategoryList,
            selectedCategories,
            clickCategory,
            keywordMap,
            clickKeyword,
            selectedKeyword,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

.product-list {
    width: 80%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}

ul {
    list-style-type: none;
    list-style: none;
}

.selected {
    background: #00a7e7 !important;
    color: white;
    font-weight: bold;
}

span {
    height: 20px;
}
</style>
